// extracted by mini-css-extract-plugin
export default {"root":"_2qWHA","cover":"_2u4R-","middle":"_2pNG6","mature-block":"_3ftdP","matureBlock":"_3ftdP","underlay":"miOrm"};